import React, { PureComponent } from 'react';
import { Flex } from '../../common/Flex';
import { Banner } from './Banner';
import { UserInfo } from './UserInfo';
import { DelaySummary, ExtendedMonitoredTv, MonitoredEvent, MonitoredMeasure } from 'app/model/SOL49';
import AppContext from '../../../common/context/AppContext';
import { TvRefLocation } from 'app/model/CORE';
import { Collapse, Divider } from 'antd';
import TimeUtils from 'app/common/util/TimeUtils';
import MiniChatPanel from 'app/components/dashboard/chat/MiniChatPanel';
import { KeyIndicatorsV2 } from 'app/components/dashboard/global/KeyIndicatorsV2';
import { MainFlowsV2 } from 'app/components/dashboard/global/MainFlowsV2';
import { MonitoredEventsV2 } from 'app/components/dashboard/global/events/MonitoredEventsV2';

interface GlobalMonitoringProps {
    monitoredEvents: MonitoredEvent[];
    selectedEvents: MonitoredEvent[];
    onSelectedEventsChange: (selection: MonitoredEvent[]) => void;
    refLocs: TvRefLocation[];
    tvs: ExtendedMonitoredTv[];
    measures: MonitoredMeasure[];
    fmps: Set<string>;
    delaySummary?: DelaySummary;
}

interface GlobalMonitoringState {
    chatOrFlowsKey?: string;
    dragging: boolean;
    splitSize: string; // will be in percentage once dragged
    dividerPosition: number;
}

const { Panel } = Collapse;
const POLLING_REFRESH_INTERVAL_IN_MS = 5 * TimeUtils.SEC_TO_MS;
const MAX_ALLOWED_POLLING_COMMUNICATION_FAILURES = 20;

export class GlobalMonitoringV2 extends PureComponent<GlobalMonitoringProps, GlobalMonitoringState> {
    constructor(props: GlobalMonitoringProps) {
        super(props);

        this.state = {
            chatOrFlowsKey: '',
            dragging: false,
            splitSize: '30%',
            dividerPosition: undefined,
        };
    }

    render() {
        const chatActive = this.state.chatOrFlowsKey == 'chat';
        const minHeightEm = chatActive ? '20em' : 'unset';

        return (
            <div
                className="global-monitoring-panel"
                style={{ display: 'flex', flex: '0 1 auto', flexDirection: 'column' }}>
                <Flex size="6em">
                    <Banner dataset={AppContext.getDataset()} />
                </Flex>
                <Flex size="4em">
                    <UserInfo userProfile={AppContext.configData?.userProfile} />
                </Flex>
                <Flex
                    direction={'vertical'}
                    grow={false}
                    className={chatActive ? 'overflow' : ''}
                    style={{ minHeight: minHeightEm }}>
                    <Collapse accordion={true} onChange={key => this.setState({ chatOrFlowsKey: key as string })}>
                        <Panel key={'chat'} header={'CHAT'}>
                            <MiniChatPanel
                                userId={AppContext.configData.claimedUserId}
                                pollingIntervalInMs={POLLING_REFRESH_INTERVAL_IN_MS}
                                pausePolling={false}
                                maxNumPollingFailures={MAX_ALLOWED_POLLING_COMMUNICATION_FAILURES}
                                onChatFailure={null}
                                onNewChat={null}
                            />
                        </Panel>
                        <Panel key={'flows'} header={'MAIN FLOWS'}>
                            <MainFlowsV2 />
                        </Panel>
                    </Collapse>
                </Flex>
                <Divider type={'horizontal'} style={{ borderTop: 'solid 1em grey', margin: 0 }} />
                <Flex direction={'vertical'} className={'overflow'} grow={false}>
                    <MonitoredEventsV2 {...this.props} />
                </Flex>
                <Divider type={'horizontal'} style={{ borderTop: 'solid 1em grey', margin: 0 }} />
                <Flex direction={'vertical'} grow={false}>
                    <KeyIndicatorsV2 delaySummary={this.props.delaySummary} />
                </Flex>
            </div>
        );
    }
}
